import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import {
  MediaPage,
  areMediaSearchEqual,
  mediaLoaderDeps,
  mediaListQueryOptions,
  mediaSearchSchema,
  normalizeMediaSearch,
} from '@/features/media';

export const Route = createFileRoute('/_authed/media')({
  validateSearch: zodValidator(mediaSearchSchema),
  loaderDeps: ({ search }) => mediaLoaderDeps(search),
  loader: ({ cause, context, deps }) => {
    if (cause !== 'enter') return;
    void context.queryClient.prefetchQuery(mediaListQueryOptions(deps));
  },
  beforeLoad: ({ search }) => {
    const normalizedSearch = normalizeMediaSearch(search);

    if (!areMediaSearchEqual(search, normalizedSearch)) {
      throw redirect({
        to: '/media',
        search: normalizedSearch,
        replace: true,
      });
    }
  },
  component: () => <MediaPage />,
});
